import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';

const LANGUAGES = [
  { key: 'zh-TW', label: '繁中', full: '繁體中文', flag: '🇹🇼' },
  { key: 'en',    label: 'EN',   full: 'English',  flag: '🇬🇧' },
  { key: 'th',    label: 'ไทย',  full: 'ภาษาไทย',  flag: '🇹🇭' },
];

export default function LanguageSwitcher({ style, ghost, size = 'small', onLanguageChange }) {
  const { i18n } = useTranslation();

  const items = LANGUAGES.map(lang => ({
    key: lang.key,
    label: <span>{lang.flag} {lang.full}</span>,
    onClick: () => {
      i18n.changeLanguage(lang.key);
      if (onLanguageChange) onLanguageChange(lang.key);
    },
  }));

  const current = LANGUAGES.find(l => l.key === i18n.language) || LANGUAGES[0];

  return (
    <Dropdown menu={{ items, selectedKeys: [i18n.language] }} placement="bottomRight">
      <Button size={size} icon={<GlobalOutlined />} ghost={ghost} style={style}>
        {current.flag} {current.label}
      </Button>
    </Dropdown>
  );
}
